import * as z from "zod/v4";

export const createYotpoIntegration = {
  name: "createYotpoIntegration" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
